import React from "react";
import { RiAppleFill, RiGooglePlayFill } from "react-icons/ri";
import { Box, Link, Typography } from "@material-ui/core";
import style from "./footer.module.scss";

export const PortfolioFooter = () => {
  return (
    <Box className={style.root}>
      <Box>
        <Link
          href="https://lcardapp.com/pro/register?business"
          target="_blank"
          color="inherit"
        >
          <u> Click here to create your own digital business card</u>
        </Link>
      </Box>
      <Box className={style.credits}>
        <Box className={style.icons}>
          <RiAppleFill />
          <RiGooglePlayFill />
        </Box>
        <Typography className={style.copyright} variant="caption">
          ©{" "}
          <Link href="https://lcardapp.com/" target="_blank" color="inherit">
            L-CARD
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};
